<template>
  <div class="faq-category" :class="{open: openState}">
    <div class="category-label" @click="toggle">
      {{category.title}}
    </div>
    <div class="category-children">
      <category v-for="(item, index) in categories" :category="item" :index="index" :key="item.id"/>
      <faq-article v-for="(item, index) in articles" :article="item" :index="index" :key="item.id"/>
    </div>
  </div>
</template>

<script>
import faqArticle from "./article";
export default {
  name: "category",
  components: {
    faqArticle,
  },
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      openState: false
    }
  },
  computed: {
    categories () {
      return this.category.children ? this.category.children : [];
    },
    articles () {
      return this.category.faq_categories_articles.sort((a, b) => (a.display_order - b.display_order));
    }
  },
  methods: {
    close () {
      this.openState = false;
    },
    toggle () {
      this.openState = !this.openState;
    }
  }
}
</script>

<style scoped>
  .category-label {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/faq/category.vue